<template>
  <v-row justify="center">
    <v-dialog
      v-model="embed.show"
      :persistent="showEmbed()"
      scrollable
      :width="embedWidth()"
    >
      <v-container fluid v-show="showEmbed()" class="embed-container">
        <v-row>
          <v-col cols="12">
            <v-sheet rounded>
              <v-system-bar color="transparent" height="40">
                <!--
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="initCloseAllEmbed" dense>
                      mdi-close-circle-multiple
                    </v-icon>
                  </template>
                  <span>{{ translatedText("closeAll") }}</span>
                </v-tooltip>
                -->

                <v-spacer></v-spacer>
                >
                <v-breadcrumbs :items="inputBreadCrumbs" divider=">">
                </v-breadcrumbs>
                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      @click="initCloseEmbed"
                      dense
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                  <span>{{ translatedText("closeThis") }}</span>
                </v-tooltip>
              </v-system-bar>

              <Flap
                :menu="{
                  transactionName: embed.transactionName,
                  selected: true,
                  permission: permission,
                }"
                :session="session"
                :environment="environment"
                :generalExApplicationEx="generalExApplicationEx"
                :applicationName="applicationName"
                :inputData="embed.inputData"
                :method="embed.method"
                :closeSubmit="true"
                :inputBreadCrumbs="inputBreadCrumbs"
                :embedded="true"
                :customLanguage="customLanguage"
                :sourceActionType="embed.sourceActionType"
                :sourceAction="embed.sourceAction"
                :custom="custom"
                @exit-flap="exitFlap"
                @exit-all-flap="exitAllFlap"
                @update-notification="updateNotification"
                @switch-language="switchLanguage"
                @close-parent-embed="closeParentEmbed"
                @close-parent-all-embed="closeParentAllEmbed"
                @user-interaction="userInteraction"
                ref="embedFlapRef"
              />
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "Embed",
  props: [
    "embed",
    "session",
    "generalExApplicationEx",
    "environment",
    "permission",
    "applicationName",
    "inputBreadCrumbs",
    "customLanguage",
    "custom",
  ],
  components: {
    Flap: () => import("./../transaction/Flap"),
  },
  data() {
    return {
      maximized: false,
      callProcess: false,
    };
  },
  methods: {
    showButtonOk() {
      return true;
    },
    showButtonCancel() {
      return false;
    },
    doCloseEmbed(data) {
      this.$emit("close-embed", data, this.embed);
    },
    doCloseAll(data) {
      this.$emit("close-all-embed", data, this.embed);
    },
    callEmbed(embed) {
      this.callProcess = true;
      return embed;
    },
    invokeEmbed() {
      if (this.callProcess && this.$refs.embedFlapRef) {
        this.$refs.embedFlapRef.callFlap(
          {
            transactionName: this.embed.transactionName,
            selected: true,
          },
          this.embed.custom
        );
        this.callProcess = false;
      }
    },
    exitFlap(data) {
      this.doCloseEmbed(data);
    },
    exitAllFlap(data) {
      this.doCloseAll(data);
    },
    clickMaximize() {
      this.maximized = !this.maximized;
    },
    updateNotification(data) {
      this.$emit("update-notification", data);
    },
    switchLanguage() {
      this.$emit("switch-language");
    },

    initCloseEmbed(data) {
      this.$refs.embedFlapRef.initCloseFlap(data, this.embed);
    },
    initCloseAllEmbed(data) {
      this.$refs.embedFlapRef.initCloseAllFlap(data, this.embed);
    },

    closeParentEmbed(data, embed) {
      this.embed = embed;
      this.doCloseEmbed(data);
    },
    closeParentAllEmbed(data, embed) {
      this.embed = embed;
      this.doCloseAll(data);
    },
    showEmbed() {
      const okCustom = !this.custom || !this.custom.hideEmbed;
      return okCustom;
    },
    userInteraction(args) {
      this.$emit('user-interaction', args);
    }
  },
  updated() {
    this.invokeEmbed();
  },
};
</script>

<style scoped>
.embed-container {
  width: 98%;
}
</style>